import AttorneyNav from "./AttorneyNav";
import AttorneyHeader from "./AttorneyHeader";
import { useGetCurrentUserQuery } from "../../../api/users";
import AttorneyMobileNav from "./AttorneyMobileNav";
import useIsMobile from "../../../hooks/useIsMobile";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetUserAttorneyQuery } from "../../../api/attorneys";

const NavLayout = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useIsMobile();
  const {
    data: user,
    isLoading: isUserLoading,
    error: userError,
  } = useGetCurrentUserQuery();
  const {
    data: attorney,
    isLoading: isAttorneyLoading,
    error: attorneyError,
  } = useGetUserAttorneyQuery(user?.id ?? skipToken);

  const isLoading = isUserLoading || isAttorneyLoading;
  const error = userError ?? attorneyError ?? !attorney;

  if (isMobile) {
    return (
      <>
        <AttorneyMobileNav
          attorney={attorney}
          isLoading={isLoading}
          error={error}
        />
        {children}
      </>
    );
  }

  return (
    <>
      <AttorneyHeader
        user={user}
        attorney={attorney}
        isLoading={isLoading}
        error={error}
      />
      <AttorneyNav attorney={attorney} isLoading={isLoading} error={error} />
      {children}
    </>
  );
};

export default NavLayout;
